const S = "https://static.prod-images.emergentagent.com/jobs/6ddd7879-62ff-4778-8926-902689ccff63/images/";
const A = "https://customer-assets-gfyr7b9c.emergentagent.net/job_book-my-chef-1/artifacts/";

export const IMG = {
  heroDining: S + "7c8d855cabf26f69a997b728fa12c4ceddf5d33f84634a181786978e3bc96f65.jpeg",
  weddingHero: S + "866e9ab774817b5db1fb32e85fde0936c486e8096ff7c6d881cb5cdaed28fec3.jpeg",
  grazing: S + "cf876f48d47bd4761369d9051c56cee126c0419b3759dcb88beda695836a4b2c.jpeg",
  canapes: S + "96234c51f28e4e12c4ae3d262e0da650a5b94cc31b8a4bacb467445df3f09223.jpeg",
  djEvent: S + "c30b64a5c2f557c89de19c41dbe820f3289e611514fc7d95fdc092fa8d205d3f.jpeg",
  dinnerParty: S + "a49c3c6b7ae999362fa98115cd1103451f479d26c9860dd0e6090a741956f685.jpeg",
  corporate: S + "04ae900f32e02b8f862c6337e8f60852a4934873a5ab442816cb4725c1537d64.jpeg",
  tablescape: S + "71101414f98f3b45786f57bcdfe0c770f2dfac72736e2b8826327183a711003f.jpeg",

  chef: A + "g1mwdb57_santi%208.jfif",
  portrait: A + "gwhsk1bo_Santi%201.jpg",
  scallop: A + "7k52yz24_Santi%202.jpg",
  dessert: A + "xkvb2pzi_Santi%203.jpg",
  paella: A + "mpr662nh_Santi%204.jpg",
  canapeReal: A + "wbm3lu4n_santi%205.jpg",
  dessert2: A + "mna6fpaw_santi%206.jpg",
  pork: A + "7qdcxy7u_santi%207.jpg",
  grazingBoard: A + "shukfbnf_santi%201.webp",
  grazingTableEvent: A + "ufek5r35_santi%202.webp",
  prawnsPan: A + "akdzshuc_santi%203.webp",
  berryDessert: A + "cfa4f4p1_santi%204.webp",
  porkCarrot: A + "08xjerr5_santi%205.jpg",
  glazedDessert: A + "2iew3jpo_Santi%203.jpg",
  paellaPan: A + "7f44xobi_Santi%204.jpg",
  canapesSpread: A + "0eorm095_santi%205.jpg",
  platedStarters: A + "p8s1s1x9_santi%206.jpg",
  porchettaPlate: A + "lhc09snk_santi%207.jpg",
  logo: A + "5w6qz1hl_logo.jfif",
  heroTerrace: A + "cf12c8638b75ba32_medi%20pic.png",
};

export const CONTACT = {
  email: "mediterraneanpalate@outlook.com",
  phoneDisplay: "07349 141612",
  whatsapp: "447349141612",
  instagram: "themediterraneanpalate",
  instagramUrl: "https://instagram.com/themediterraneanpalate",
  googleReviewsUrl: "https://www.google.com/search?q=Mediterranean+Palate+private+chef+Rutland+reviews",
};
